import { boot } from 'quasar/wrappers'
import { VueCsvImportPlugin } from 'vue-csv-import'

export default boot(({ app }) => {

  app.use(VueCsvImportPlugin)
})
